export class JsClickError extends Error {
    constructor(public message: string) {
        super(message);
        this.name = 'JsClickError';
        Object.setPrototypeOf(this, JsClickError.prototype);
    }
}
